import styled from "styled-components";
import Search from "shared/components/Search";
import useViewLesson from "features/teacher/hooks/lesson/useViewLesson";
import { useNavigate } from "react-router-dom";
import PLUS_SVG from "assets/images/plus.svg";
import { hw, scrollbar } from "features/homework/homeworkUi";

const ViewLesson = () => {
    const { searchedLessons, search, onChange } = useViewLesson();
    const navigate = useNavigate();

    return (
        <Page>
            <PageHeader>
                <div>
                    <Title>학급관리</Title>
                    <Desc>학급을 선택하면 원생·출결을 볼 수 있습니다.</Desc>
                </div>
            </PageHeader>
            <Panel>
                <Toolbar>
                    <Search placeholder="학급을 입력해 주세요" onChange={onChange} value={search} />
                </Toolbar>
                <Grid>
                    <AddTile type="button" onClick={() => navigate("/teacher/lesson/manage", { state: "학급관리" })}>
                        <PlusIcon src={PLUS_SVG} alt="" />
                        <AddText>학급 추가</AddText>
                    </AddTile>
                    {searchedLessons.length === 0 && !search ? null : searchedLessons.map((lesson) => (
                        <Tile
                            key={lesson.id}
                            type="button"
                            onClick={() => navigate("/teacher/lesson/view/student", { state: lesson.id })}
                        >
                            <Name>{lesson.name}</Name>
                            <Teacher>{lesson.teacher || "담당 교사 없음"}</Teacher>
                        </Tile>
                    ))}
                    {searchedLessons.length === 0 && search ? (
                        <Empty>검색 결과가 없습니다.</Empty>
                    ) : null}
                </Grid>
            </Panel>
        </Page>
    );
};

const Page = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
`;

const PageHeader = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px 16px;
    flex-shrink: 0;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${hw.text};
`;

const Desc = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${hw.textMuted};
`;

const Panel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    padding: 18px 20px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
`;

const Toolbar = styled.div`
    max-width: 360px;
    flex-shrink: 0;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
    align-content: start;
    flex: 1;
    min-height: 0;
    overflow: auto;
    ${scrollbar}
`;

const tileBase = `
    appearance: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    min-height: 120px;
    padding: 20px 16px;
    border-radius: 14px;
    cursor: pointer;
    text-align: center;
`;

const Tile = styled.button`
    ${tileBase}
    background: ${hw.surface};
    border: 1px solid ${hw.border};

    &:hover {
        border-color: ${hw.brandMuted};
        background: ${hw.brandSoft};
    }
`;

const AddTile = styled.button`
    ${tileBase}
    background: ${hw.bg};
    border: 1px dashed ${hw.border};

    &:hover {
        border-color: ${hw.brand};
        background: ${hw.brandSoft};
    }
`;

const PlusIcon = styled.img`
    width: 22px;
    height: 22px;
    opacity: 0.55;
`;

const AddText = styled.span`
    color: ${hw.textMuted};
    font-size: 14px;
    font-weight: 600;
`;

const Name = styled.span`
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const Teacher = styled.span`
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 500;
`;

const Empty = styled.div`
    grid-column: 1 / -1;
    padding: 40px 16px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`;

export default ViewLesson;
